// Manejar con sessionStorage las reservas que selecciono
// si aun no habia iniciado sesion y seleccion otra fecha

export function setDateSelectedRvsStore(date, isUser) {
  if (!isUser) {
    sessionStorage.setItem("selected", date);
  }
}

export function getDateSelectedRvsStore() {
  return sessionStorage.getItem("selected") ?? null;
}

export function removeDateSelectedRvsStore() {
  sessionStorage.removeItem("selected");
}
